import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CircularProgress,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import styled from "styled-components";
import { ActionButton } from "../shared/action-button";
import DownloadIcon from "@mui/icons-material/Download";

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #1F2735;
  color: white;
`;

const Footer = styled(DialogActions)`
  background-color: #1F2735;
  padding: 12px 24px 16px 24px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DownloadStudiesModal = ({
  open,
  onClose,
  studies,
  onSubmit,
  loading,
}) => {
  const [selectedStudies, setSelectedStudies] = useState([]);

  const handleToggle = (studyId) => {
    setSelectedStudies((prev) =>
      prev.includes(studyId)
        ? prev.filter((id) => id !== studyId)
        : [...prev, studyId]
    );
  };

  const handleSubmit = () => {
    onSubmit(selectedStudies);
    setSelectedStudies([]);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <ModalHeader title={`Select Studies to Download`} icon={<DownloadIcon />} onClose={onClose} />
      <Content>
        <List>
          {studies.map((study) => (
            <ListItem key={study.StudyInstanceUID} disablePadding>
              <ListItemIcon>
                <Checkbox
                  checked={selectedStudies.includes(study.StudyInstanceUID)}
                  onChange={() => handleToggle(study.StudyInstanceUID)}
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={`${new Date(study.StudyDate).toLocaleDateString(
                  "en-US",
                  { year: "numeric", month: "2-digit", day: "2-digit" }
                )} - ${study.Modality || ""} - ${
                  study.StudyDescription || "No Description"
                }`}
              />
            </ListItem>
          ))}
        </List>
      </Content>

      <Footer>
        <ActionButton variantType="outlined" colorType="negative" onClick={onClose}>
          Cancel
        </ActionButton>
        <ActionButton
          variantType="filled"
          onClick={handleSubmit}
          disabled={loading || selectedStudies.length === 0}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Download"
          )}
        </ActionButton>
      </Footer>
    </Dialog>
  );
};

export default DownloadStudiesModal;
